import React from 'react';

interface ArticleStructuredDataProps {
  title: string;
  description: string;
  url: string;
  image?: string;
  author: string;
  publishedTime: string;
  modifiedTime?: string;
  section: string;
  tags: string[];
}

interface OrganizationStructuredDataProps {
  name: string;
  description: string;
  url: string;
  logo: string;
  email: string;
}

export const ArticleStructuredData: React.FC<ArticleStructuredDataProps> = ({
  title,
  description,
  url,
  image = '/logo512.png',
  author,
  publishedTime,
  modifiedTime,
  section,
  tags
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "image": image,
    "url": url,
    "author": {
      "@type": "Organization",
      "name": author,
      "url": "https://www.oteudinheiro.com.br"
    },
    "publisher": {
      "@type": "Organization",
      "name": "O Teu Dinheiro",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.oteudinheiro.com.br/logo512.png"
      }
    },
    "datePublished": publishedTime,
    "dateModified": modifiedTime || publishedTime,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "articleSection": section,
    "keywords": tags.join(", "),
    "inLanguage": "pt-BR"
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export const OrganizationStructuredData: React.FC<OrganizationStructuredDataProps> = ({
  name,
  description,
  url,
  logo,
  email
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": name,
    "description": description,
    "url": url,
    "logo": logo,
    "contactPoint": {
      "@type": "ContactPoint",
      "email": email,
      "contactType": "customer service"
    },
    "sameAs": [
      // Add social media URLs when available
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export const WebsiteStructuredData: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "O Teu Dinheiro",
    "description": "Educação financeira simples e prática para o brasileiro",
    "url": "https://www.oteudinheiro.com.br",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.oteudinheiro.com.br/blog?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};
